import React from "react";

function Invalid() {
  return <h3 style={{textAlign:"center", marginTop:"32.8vh",minHeight:"50vh" }}>
The page you are looking for does not exist.
  </h3>;
}
export default Invalid;
